module.exports = __webpack_public_path__ + "img/k_sj.70f9dfef.png";